export default __webpack_public_path__ + "static/media/logo-mini.e9bec0d6.png";